import { Control, FieldErrors } from 'react-hook-form';
import { itemsAreAllVirtual } from 'utils/cartUtils';
import { useCartContext } from 'CartContext';
import countriesData from 'assets/countries.json';
import { ReactElement, useState, useEffect } from 'react';
import StateDropdownField from './StateDropdownField';
import CountryDropdown from './CountryDropdownField';

export interface FormInputProps<TFieldValues> {
  control: Control<TFieldValues>;
  errors?: FieldErrors;
}

export interface CountryOrStateValues {
  name: string;
  iso3?: string;
  code: string;
}

export default function FormInput<TFieldValues>(
  props: FormInputProps<TFieldValues>,
): ReactElement {
  //* errors is not used here but is needed for AddressFormInput.tsx
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const { control, errors } = props;
  const { items } = useCartContext();
  const virtualItemsOnly = itemsAreAllVirtual(items);
  // react states for CountryDropdown component are stored here since they need to be passed to StateDropdown component:
  const [countries, setCountries] = useState<CountryOrStateValues[]>(
    countriesData as CountryOrStateValues[],
  );
  const [localCountry, setLocalCountry] = useState<string>('');
  const [selectedCountry, setSelectedCountry] = useState<
    CountryOrStateValues | undefined
  >(
    !virtualItemsOnly
      ? {
          name: 'United States',
          iso3: 'USA',
          code: 'US',
        }
      : undefined,
  );

  useEffect(() => {
    if (localCountry) {
      const findCountry = countries.find(
        country => country.code.toLowerCase() === localCountry.toLowerCase(),
      );
      setSelectedCountry(findCountry);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [localCountry]);

  return (
    <>
      <CountryDropdown
        control={control}
        selectedCountryCode={selectedCountry?.code}
        setCountries={setCountries}
        countries={countries}
        setSelectedCountry={setSelectedCountry}
        setLocalCountry={setLocalCountry}
        localCountry={localCountry}
        countriesData={countriesData}
        selectedCountry={selectedCountry}
        virtualItemsOnly={virtualItemsOnly}
      />

      <StateDropdownField
        control={control}
        selectedCountryCode={selectedCountry?.code}
      />
    </>
  );
}
